<template>
  <div>
    <h1 class="pa-3 text-xs-center">MERCHANT NEWS</h1>
    <v-card class="mb-2">
      <v-card-text>
        <h2 class="pb-2">Send Merchant News</h2>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex sm6 xs12>
              <v-text-field
                v-model="form.notification_title_th"
                :rules="[(v) => !!v || 'Title TH is required']"
                label="Title (TH)"
                class="pr-3"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field
                v-model="form.notification_title_en"
                :rules="[(v) => !!v || 'Title EN is required']"
                label="Title (EN)"
                class="pr-3"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm6 xs12>
              <v-textarea
                v-model="form.notification_detail_th"
                :rules="[(v) => !!v || 'Description TH is required']"
                label="Description (TH)"
                class="pr-3"
              ></v-textarea>
            </v-flex>
            <v-flex sm6 xs12>
              <v-textarea
                v-model="form.notification_detail_en"
                :rules="[(v) => !!v || 'Description EN is required']"
                label="Description (EN)"
                class="pr-3"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-radio-group
            v-model="form.notification_type"
            :rules="[(v) => !!v || 'Type is required']"
            row
            label="Notification type: "
          >
            <v-radio label="All" :value="1"></v-radio>
            <v-radio label="Province" :value="2"></v-radio>
          </v-radio-group>
          <transition name="fade">
            <v-select
              v-if="form.notification_type == 2"
              clearable
              item-text="province_name_th"
              item-value="province_id"
              v-model="form.notification_province_id"
              :items="provinceData"
              chips
              label="Province"
              multiple
              :rules="[(v) => v.length > 0 || 'Please select a province']"
            ></v-select>
          </transition>
          <v-btn :loading="isSending" @click="send()">Send</v-btn>
          <v-btn :disabled="isSending" @click="clear()">Clear</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <h2 class="pb-2">Merchant News List</h2>
        <v-data-table
          :rows-per-page-items="[5, 10, 20, 50, 100]"
          :headers="headers"
          :loading="isLoading"
          :items="notificationList"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.notification_title_th }}</td>
            <td>{{ props.item.notification_title_en }}</td>
            <td>{{ props.item.notification_detail_th }}</td>
            <td>{{ props.item.notification_detail_en }}</td>
            <td>
              <span
                v-if="
                  props.item.notification_province_id.length > 0 &&
                  props.item.notification_province_id[0] == 0
                "
                class="pl-3"
                >All</span
              >
              <ul
                v-if="
                  props.item.notification_province_id.length > 0 &&
                  props.item.notification_province_id[0] != 0
                "
              >
                <li
                  v-for="(info, index) in props.item.notification_province_id"
                  :key="index"
                >
                  {{ showProvince(info) }}
                </li>
              </ul>
            </td>
            <td>
              {{ props.item.notification_is_order == true ? "Yes" : "No" }}
            </td>
            <td>
              <v-tooltip top>
                <v-btn
                  :loading="isResending.includes(props.item.notification_id)"
                  icon
                  @click="resend(props.item)"
                  slot="activator"
                >
                  <v-icon>send</v-icon>
                </v-btn>
                <span>Resend</span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <v-btn   :loading="isDeleting.includes(props.item.notification_id)" icon @click="deleteHistory(props.item)" slot="activator">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Delete</span>
              </v-tooltip>-->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "Title (TH)",
          sortable: false,
          value: "notification_title_th",
        },
        { text: "Title (EN)", sortable: false, value: "notification_title_en" },
        {
          text: "Description (TH)",
          sortable: false,
          value: "notification_detail_th",
        },
        {
          text: "Description (EN)",
          sortable: false,
          value: "notification_detail_en",
        },
        { text: "Province", sortable: false, value: "protein" },
        { text: "Is order ? ", sortable: false, value: "protein" },
        { text: "", sortable: false, value: "protein" },
      ],
      isLoading: false,
      isResending: [],
      isDeleting: [],
      isSending: false,
      valid: true,
      form: {
        notification_type: 1,
        notification_title_th: "",
        notification_title_en: "",
        notification_detail_th: "",
        notification_detail_en: "",
        notification_package_id: [0],
        notification_province_id: [],
        notification_store_id: [0],
      },
    };
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      notificationList: (state) => state.advertising.merchantNotificationList,
    }),
  },
  methods: {
    showProvince(id) {
      let findProvince = this.provinceData.find((val) => val.province_id == id);
      return findProvince == undefined ? "" : findProvince.province_name_en;
    },
    async deleteHistory(info) {
      this.isDeleting.push(info.notification_id);
      await this.$store.dispatch(
        "advertising/deleteMerchantNotification",
        info.notification_id
      );
      let index = this.isDeleting.findIndex(
        (val) => val == info.notification_id
      );
      this.isDeleting.splice(index, 1);
    },
    async resend(info) {
      this.isResending.push(info.notification_id);
      let result = await this.$store.dispatch(
        "advertising/sendMerchantNotification",
        info
      );
      if (result == true) {
        alert("Resend successfully");
        this.fetchData();
      }
      let index = this.isResending.findIndex(
        (val) => val == info.notification_id
      );
      this.isResending.splice(index, 1);
    },
    async send() {
      if (this.$refs.form.validate()) {
        this.isSending = true;
        let formData = JSON.parse(JSON.stringify(this.form));
        if (formData.notification_type == 1) {
          formData.notification_province_id = [0];
        }
        let result = await this.$store.dispatch(
          "advertising/sendMerchantNotification",
          formData
        );
        if (result == true) {
          alert("Send successfully");
          this.fetchData();
          this.clear();
        }
        this.isSending = false;
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.form = {
        notification_type: 1,
        notification_title_th: "",
        notification_title_en: "",
        notification_detail_th: "",
        notification_detail_en: "",
        notification_package_id: [0],
        notification_province_id: [],
        notification_store_id: [0],
      };
    },
    async fetchData() {
      this.isLoading = true;
      await this.$store.dispatch("advertising/getMerchantNotification");
      this.isLoading = false;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    const path = [
      {
        text: "Home",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Merchant News",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style lang="scss" scoped>
</style>